import CreateRoutes from "./routes";

export default function App() {
  return <CreateRoutes />;
}

